import React from 'react';
import './Common.css';

const LoadingSpinner = ({ size = 'medium', message = 'Loading...' }) => {
  const getSpinnerClass = () => {
    switch(size) {
      case 'small': return 'spinner-small';
      case 'large': return 'spinner-large';
      default: return 'spinner-medium';
    }
  };

  return (
    <div className="loading-container">
      <div className={`loading-spinner ${getSpinnerClass()}`}>
        <div className="spinner-border"></div>
      </div>
      {message && <div className="loading-message">{message}</div>}
    </div>
  );
};

export default LoadingSpinner;